import React, { memo, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import ReactECharts from "echarts-for-react";
import { formatNumber, getShortenMark, isNullOrEmpty, shortenNumberAutoK } from "../../helpers/utils";

export default memo(
  function IDXDetailChart(props) {
    const { indexCode, priorIndex } = props; // priorIndex: gia tri nguyen chua chia
    //
    const { t } = useTranslation();
    const language = useSelector((state) => state.gShared.language);
    const counter = useSelector((state) => state.gIndex.indexChart[indexCode]?.counter);
    const chartDatas = useSelector((state) => state.gIndex.indexChart[indexCode]?.datas);
    //
    const refChart = useRef(null);

    //
    const _formatNumberChart = (value) => {
      return shortenNumberAutoK(value, null, { showMark: false, maximumFractionDigits: 1 }) + getShortenMark(value, language);
    };

    // console.log(indexCode, priorIndex, "priorIndexpriorIndex");

    const _getChartOptions = () => {
      let _indexValues = [],
        _tradedQuantities = [];
      if (chartDatas && chartDatas.length > 0) {
        for (let index = 0; index < chartDatas.length; index++) {
          if (index == 0
            && (isNullOrEmpty(chartDatas[index].value) || chartDatas[index].value === 0)
            && (isNullOrEmpty(chartDatas[index].quantity) || chartDatas[index].quantity === 0)
          ) {
            _indexValues.push([chartDatas[index].time, null]);
            _tradedQuantities.push([chartDatas[index].time, null]);
            continue;
          }

          const _isTemp = chartDatas[index].isTemp === "Y" ? true : false;
          const _value = _isTemp == false ? Number(chartDatas[index].value.toFixed(2)) : null;
          const _quantity = _isTemp == false ? chartDatas[index].quantity : null;
          _indexValues.push([chartDatas[index].time, _value]);
          _tradedQuantities.push([chartDatas[index].time, _quantity]);
        }

        _indexValues = _indexValues.sort((a, b) => a[0] - b[0]);
        _tradedQuantities = _tradedQuantities.sort((a, b) => a[0] - b[0]);
      }
      //
      // console.log(_indexValues,_tradedQuantities,  "aa");


      return {
        useUTC: false,
        textStyle: {
          fontFamily: "tahoma, 'Be Vietnam Pro'",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          textStyle: {
            // lineHeight: 30,
            color: "#fff",
            fontSize: 12,
            lineHeight: "21px",
          },
          padding: [5, 9],
          confine: true,
          backgroundColor: "rgba(47, 62, 76, 0.9)",
          borderColor: "transparent",
          formatter: function (params) {
            //console.log(params);
            let rez = "<p>" + params[0].axisValueLabel + "</p>";
            params.forEach((item) => {
              var _value = "";

              if (item.seriesIndex === 0) {
                _value = formatNumber(item.data[1]);
              } else {
                _value = _formatNumberChart(item.data[1]);
              }

              rez +=
                '<p class="chart-tooltip-row">' +
                item.marker +
                "<span>" +
                item.seriesName +
                ":</span>" +
                '<b class="text-right">' +
                _value +
                "</b></p>";
            });
            return rez;
          },
        },
        visualMap: {
          show: false,
          seriesIndex: 0,
          pieces: [
            {
              gte: -10000000,
              lt: priorIndex,
              color: "#cf3827",
            },
            {
              gte: priorIndex,
              lte: priorIndex,
              color: "#FFD500",
            },
          ],
          outOfRange: {
            color: "#00b200",
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            hideOverlap: true,
            showMinLabel: true,
            showMaxLabel: true,
            formatter: function (value, index) {
              var _lblDate = new Date(value);
              return _lblDate.getHours() + ":" + _lblDate.getMinutes();
            },
          },
          axisLine: {
            onZero: false,
            // show: true,
          },
        },
        yAxis: [
          {
            type: "value",
            position: "left",
            splitLine: {
              show: false,
              lineStyle: {
                color: "#666",
              },
            },
            axisLabel: {
              show: false,
              color: "#ccc",
              formatter: function (value, index) {
                return value.toFixed(0);
              },
              verticalAlign: "top",
              showMinLabel: false,
            },
            min: function (value) {
              const min = Math.min(value.min, priorIndex);
              const max = Math.max(value.max, priorIndex);
              let addNumber = (max - min) * 0.3;
              if (addNumber === 0) {
                addNumber = 0.01;
              }
              return min - addNumber;
            },
            max: function (value) {
              const min = Math.min(value.min, priorIndex);
              const max = Math.max(value.max, priorIndex);
              let addNumber = (max - min) * 0.3;
              if (addNumber === 0) {
                addNumber = 0.01;
              }
              return max + addNumber;
            },
            axisLine: {
              onZero: false,
            },
            alignTicks: true,
            // splitNumber: 1
          },
          {
            type: "value",
            position: "right",
            splitLine: {
              show: false,
              lineStyle: {
                color: "#666",
              },
            },
            axisLabel: {
              show: false,
              color: "#ccc",
              formatter: function (value, index) {
                return index === 0 ? 0 : _formatNumberChart(value);
              },
              verticalAlign: "top",
              showMinLabel: true,
              // align: 'right',
            },
            min: 0,
            max: function (value) {
              return value.max !== value.min ? Math.ceil(value.max * 1.25) : value.max;
            },
            alignTicks: true,
            axisLine: {
              onZero: true,
            },
            // splitNumber: 3
          },
        ],
        series: [
          {
            yAxisIndex: 0,
            name: t("giaTriChiSo1"),
            data: _indexValues,
            connectNulls: true,
            type: "line",
            smooth: true,
            symbol: "none",
            lineStyle: {
              width: 2,
            },
            markLine: {
              silent: true,
              symbol: "none",
              lineStyle: {
                color: "#ccaa00",
              },
              label: {
                position: "middle",
                color: "#FFF",
                fontSize: 9,
                lineHeight: 1,
              },
              data: [
                {
                  yAxis: priorIndex,
                },
              ],
            },
            large: true,
          },
          {
            yAxisIndex: 1,
            name: t("tongKL"),
            data: _tradedQuantities,
            connectNulls: true,
            type: "bar",
            itemStyle: {
              color: "#587599",
            },
            barMaxWidth: 30,
          },
        ],
        grid: {
          left: "10px",
          right: "10px",
          top: "0",
          bottom: "0",
          containLabel: true,
          background: "#fff",
          border: "1px solid #fff",
        },
      };
    };
    //
    useEffect(() => {
      if (refChart && refChart.current) {
        refChart.current.getEchartsInstance().setOption(_getChartOptions());
      }
    });
    //
    return <>{chartDatas ? <ReactECharts style={{ ...props.style }} ref={refChart} lazyUpdate={true} option={_getChartOptions()} /> : <></>}</>;
  },
  (prevProps, nextProps) => {
    if (prevProps.indexCode === nextProps.indexCode && prevProps.priorIndex === nextProps.priorIndex) {
      return true; // props are equal
    }
    return false; // props are not equal -> update the component
  }
);
